var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"footer-section"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.title))])]),(_vm.footerSection)?_c('EditableArea',{attrs:{"content":_vm.footerSection}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }